import React from 'react'
import {StoreProvider} from "./store";
import {Main} from "./Main";

export default function () {
  return (
    <StoreProvider>
      <Main/>
    </StoreProvider>)
}